import React, { FC, memo, ReactNode } from "react";
import { createPortal } from "react-dom";
import { FocusOn } from "react-focus-on";
import {
  Overlay,
  ModalContent,
  CloseButton,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "./Modal.styles";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  footer?: ReactNode;
  closeDisabled?: boolean;
}

const Modal: FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  closeDisabled = false,
}) => {
  if (!isOpen) return null;

  return createPortal(
    <Overlay>
      <FocusOn>
        <ModalContent>
          <CloseButton onClick={onClose} disabled={closeDisabled} />
          {title && <ModalHeader>{title}</ModalHeader>}
          <ModalBody>{children}</ModalBody>
          {footer && <ModalFooter>{footer}</ModalFooter>}
        </ModalContent>
      </FocusOn>
    </Overlay>,
    document.body,
  );
};

export default memo(Modal);
